import Inter from 'src/assets/fonts/Inter.var.woff2';
import InterBlack from 'src/assets/fonts/Inter-Black.woff';
import InterBlack2 from 'src/assets/fonts/Inter-Black.woff2';
import InterBlackItalic from 'src/assets/fonts/Inter-BlackItalic.woff';
import InterBlackItalic2 from 'src/assets/fonts/Inter-BlackItalic.woff2';
import InterBold from 'src/assets/fonts/Inter-Bold.woff';
import InterBold2 from 'src/assets/fonts/Inter-Bold.woff2';
import InterBoldItalic from 'src/assets/fonts/Inter-BoldItalic.woff';
import InterBoldItalic2 from 'src/assets/fonts/Inter-BoldItalic.woff2';
import InterExtraBold from 'src/assets/fonts/Inter-ExtraBold.woff';
import InterExtraBold2 from 'src/assets/fonts/Inter-ExtraBold.woff2';
import InterExtraBoldItalic from 'src/assets/fonts/Inter-ExtraBoldItalic.woff';
import InterExtraBoldItalic2 from 'src/assets/fonts/Inter-ExtraBoldItalic.woff2';
import InterExtraLight from 'src/assets/fonts/Inter-ExtraLight.woff';
import InterExtraLight2 from 'src/assets/fonts/Inter-ExtraLight.woff2';
import InterExtraLightItalic from 'src/assets/fonts/Inter-ExtraLightItalic.woff';
import InterExtraLightItalic2 from 'src/assets/fonts/Inter-ExtraLightItalic.woff2';
import InterItalicVar from 'src/assets/fonts/Inter-italic.var.woff2';
import InterItalic from 'src/assets/fonts/Inter-Italic.woff';
import InterItalic2 from 'src/assets/fonts/Inter-Italic.woff2';
import InterLight from 'src/assets/fonts/Inter-Light.woff';
import InterLight2 from 'src/assets/fonts/Inter-Light.woff2';
import InterLightItalic from 'src/assets/fonts/Inter-LightItalic.woff';
import InterLightItalic2 from 'src/assets/fonts/Inter-LightItalic.woff2';
import InterMedium from 'src/assets/fonts/Inter-Medium.woff';
import InterMedium2 from 'src/assets/fonts/Inter-Medium.woff2';
import InterMediumItalic from 'src/assets/fonts/Inter-MediumItalic.woff';
import InterMediumItalic2 from 'src/assets/fonts/Inter-MediumItalic.woff2';
import InterRegular from 'src/assets/fonts/Inter-Regular.woff';
import InterRegular2 from 'src/assets/fonts/Inter-Regular.woff2';
import InterRomanVar from 'src/assets/fonts/Inter-roman.var.woff2';
import InterSemiBold from 'src/assets/fonts/Inter-SemiBold.woff';
import InterSemiBold2 from 'src/assets/fonts/Inter-SemiBold.woff2';
import InterSemiBoldItalic from 'src/assets/fonts/Inter-SemiBoldItalic.woff';
import InterSemiBoldItalic2 from 'src/assets/fonts/Inter-SemiBoldItalic.woff2';
import InterThin from 'src/assets/fonts/Inter-Thin.woff';
import InterThin2 from 'src/assets/fonts/Inter-Thin.woff2';
import InterThinItalic from 'src/assets/fonts/Inter-ThinItalic.woff';
import InterThinItalic2 from 'src/assets/fonts/Inter-ThinItalic.woff2';

export const muiCssBaseline = {
  styleOverrides:
    `
    body {
      font-family: "Inter", sans-serif;
    }
    ` +
    // Font: Inter
    `
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 100;
      font-display: swap;
      src: url(${InterThin2}) format("woff2"),
           url(${InterThin}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 100;
      font-display: swap;
      src: url(${InterThinItalic2}) format("woff2"),
           url(${InterThinItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 200;
      font-display: swap;
      src: url(${InterExtraLight2}) format("woff2"),
           url(${InterExtraLight}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 200;
      font-display: swap;
      src: url(${InterExtraLightItalic2}) format("woff2"),
           url(${InterExtraLightItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 300;
      font-display: swap;
      src: url(${InterLight2}) format("woff2"),
           url(${InterLight}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 300;
      font-display: swap;
      src: url(${InterLightItalic2}) format("woff2"),
           url(${InterLightItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 400;
      font-display: swap;
      src: url(${InterRegular2}) format("woff2"),
           url(${InterRegular}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 400;
      font-display: swap;
      src: url(${InterItalic2}) format("woff2"),
           url(${InterItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 500;
      font-display: swap;
      src: url(${InterMedium2}) format("woff2"),
           url(${InterMedium}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 500;
      font-display: swap;
      src: url(${InterMediumItalic2}) format("woff2"),
           url(${InterMediumItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 600;
      font-display: swap;
      src: url(${InterSemiBold2}) format("woff2"),
           url(${InterSemiBold}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 600;
      font-display: swap;
      src: url(${InterSemiBoldItalic2}) format("woff2"),
           url(${InterSemiBoldItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 700;
      font-display: swap;
      src: url(${InterBold2}) format("woff2"),
           url(${InterBold}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 700;
      font-display: swap;
      src: url(${InterBoldItalic2}) format("woff2"),
           url(${InterBoldItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 800;
      font-display: swap;
      src: url(${InterExtraBold2}) format("woff2"),
           url(${InterExtraBold}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 800;
      font-display: swap;
      src: url(${InterExtraBoldItalic2}) format("woff2"),
           url(${InterExtraBoldItalic}) format("woff");
    }
    
    @font-face {
      font-family: 'Inter';
      font-style:  normal;
      font-weight: 900;
      font-display: swap;
      src: url(${InterBlack2}) format("woff2"),
           url(${InterBlack}) format("woff");
    }
    @font-face {
      font-family: 'Inter';
      font-style:  italic;
      font-weight: 900;
      font-display: swap;
      src: url(${InterBlackItalic2}) format("woff2"),
           url(${InterBlackItalic}) format("woff");
    }
    ` +
    /* -------------------------------------------------------
    Variable font.
    Usage:

      html { font-family: 'Inter', sans-serif; }
      @supports (font-variation-settings: normal) {
        html { font-family: 'Inter var', sans-serif; }
      }
    */
    `
    @font-face {
      font-family: 'Inter var';
      font-weight: 100 900;
      font-display: swap;
      font-style: normal;
      font-named-instance: 'Regular';
      src: url(${InterRomanVar}) format("woff2");
    }
    @font-face {
      font-family: 'Inter var';
      font-weight: 100 900;
      font-display: swap;
      font-style: italic;
      font-named-instance: 'Italic';
      src: url(${InterItalicVar}) format("woff2");
    }
    ` +
    /* --------------------------------------------------------------------------
    [EXPERIMENTAL] Multi-axis, single variable font.

    Slant axis is not yet widely supported (as of February 2019) and thus this
    multi-axis single variable font is opt-in rather than the default.

    When using this, you will probably need to set font-variation-settings
    explicitly, e.g.

      * { font-variation-settings: "slnt" 0deg }
      .italic { font-variation-settings: "slnt" 10deg }

    */
    `
    @font-face {
      font-family: 'Inter var experimental';
      font-weight: 100 900;
      font-display: swap;
      font-style: oblique 0deg 10deg;
      src: url(${Inter}) format("woff2");
    }
    `,
};
